import global from "../global.js";
import uuid from "../../library/uuid.js";
const d3 = global.d3;

import Transform from "./Transform.js";

// const log = global.log.getLogger("f_mtac.utils.svgshadow");

const SVGShadow = function(svg) {
    this.transform = new Transform({k: 1});
    this.transform.on_scale(({k}) => {
        gaussian_blur
            .attr("stdDeviation", sd / k);
        offset
            .attr("dx", dx / k)
            .attr("dy", dy / k);
    });

    const dx = 5, dy = 5, sd = 2;

    const id = uuid();
    const filter = d3.create("svg:filter").attr("id", id);
    const gaussian_blur = filter.append("feGaussianBlur").attr("in", "SourceAlpha")
        .attr("stdDeviation", sd / this.transform.k);
    const offset = filter.append("feOffset").attr("result", "offsetblur")
        .attr("dx", dx / this.transform.k)
        .attr("dy", dy / this.transform.k);
    const components = filter.append("feComponentTransfer");
    components.append("feFuncA").attr("type", "linear").attr("slope", "0.8"); // opacity of the shadow

    const merge = filter.append("feMerge");
    merge.append("feMergeNode"); // contains the offset blurred image
    merge.append("feMergeNode").attr("in", "SourceGraphic"); // contains the element that the filter is applied to

    svg.defs.append(() => filter.node());

    this.affect = (element) => {
        element.attr("filter", `url(#${id})`);
    };

    this.unaffect = (element) => {
        element.attr("filter", null);
    };


};

export default SVGShadow;
